import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { useTableLayoutEnabled } from '../layouts/table_layout.js';
import { groupColumns } from './_grouping.js';
import { FooterCell } from './footer_cell.js';
export function FooterRow({ appearance = 'primary', footerGroup }) {
    const { selectRowColumn, groupedColumns, leftStickyColumns, generalColumns, rightStickyColumns } = groupColumns(footerGroup.headers);
    const tableLayoutEnabled = useTableLayoutEnabled();
    const className = classNames('twds-box-border', tableLayoutEnabled || appearance === 'secondary'
        ? 'twds-border-r-0'
        : 'twds-border twds-border-r-0 twds-border-gray-950');
    const { key, ...footerGroupProps } = footerGroup.getFooterGroupProps({
        role: 'row',
        style: {
            display: 'flex',
            minHeight: appearance === 'primary' ? '2rem' : '1rem',
            marginBottom: tableLayoutEnabled ? '-1px' : '',
            width: ''
        }
    });
    return (React.createElement("div", { key: key, ...footerGroupProps, className: className },
        !!selectRowColumn.length && (React.createElement("div", { className: "twds-flex" }, selectRowColumn.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance }))))),
        !!groupedColumns.length && (React.createElement("div", { className: "twds-flex" }, groupedColumns.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance }))))),
        !!leftStickyColumns.length && (React.createElement("div", { className: "twds-flex" }, leftStickyColumns.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance }))))),
        !!generalColumns.length && (React.createElement("div", { className: "twds-flex twds-flex-grow" }, generalColumns.map((column, index) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance, lastCell: generalColumns.length === index + 1 }))))),
        !!rightStickyColumns.length && (React.createElement("div", { className: "twds-flex twds-shadow-right dark:twds-shadow-dark-right", style: {
                background: 'inherit',
                position: 'sticky',
                right: 0
            } }, rightStickyColumns.map((column) => (React.createElement(FooterCell, { column: column, key: column.id, appearance: appearance })))))));
}
//# sourceMappingURL=footer_row.js.map